import { orchestrator } from 'satcheljs';
import { updateCachedCharms } from '../actions/updateCachedCharms';
import { updateCalendarFolder } from 'owa-calendar-cache';

orchestrator(updateCalendarFolder, actionMessage => {
    const { calendarFolder } = actionMessage;
    // if we change a charm property, that propagates to items on the surface so we need to update those as well
    if (calendarFolder.CharmId != undefined) {
        updateCachedCharms(calendarFolder.CharmId, calendarFolder.FolderId.Id);
    }
});
